<template>
    <div>
        <div class="wrap1200 breadcrumb">
            <breadcrumb></breadcrumb>
        </div>
        <router-view></router-view>
        <div class="infoMain wrap1200">
            <div class="matchType">
                <ul>
                    <li v-for="(item,index) in ballTypeList" 
                        :key="index"
                        :class="{selected: selectedIndex === index}"
                        @click="selectType(index)">
                        <span v-if="selectedIndex === index" class="select-bar"></span>
                        {{ item.name }}
                    </li>
                </ul>
            </div>
            <div class="matchMain">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane v-for="(item,index) in list" :key="index" :label="item.name" :name="item.bynameL">
                        <div class="points" v-if="item.bynameL === 'standing'">
                            <div class="noData" v-if="curIndex == 0 && selectedIndex == 6">
                                暂无数据
                            </div>
                            <div v-else>
                                <div class="pointsTitle">{{ tableData.name }}</div>
                                <el-table
                                :data="tableData.data"
                                style="width: 100%">
                                    <el-table-column prop="rank" label="排名"></el-table-column>
                                    <el-table-column label="球队" width="220">
                                        <template slot-scope="scope">
                                            <div class="team-icon">
                                                <img :src="scope.row.team_logo">
                                                <b>{{ scope.row.team_name }}</b>
                                            </div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="matches_total" label="场次"></el-table-column>
                                    <el-table-column prop="matches_won" label="胜"></el-table-column>
                                    <el-table-column prop="matches_draw" label="平"></el-table-column>
                                    <el-table-column prop="matches_lost" label="负"></el-table-column>
                                    <el-table-column prop="goals_pro" label="进球"></el-table-column>
                                    <el-table-column prop="goals_against" label="失球"></el-table-column>
                                    <el-table-column :formatter="(row) => row.goals_pro - row.goals_against" label="净胜球"></el-table-column>
                                    <el-table-column prop="points" label="积分"></el-table-column>
                                </el-table>
                            </div>
                        </div>
                        <div v-else-if="item.bynameL === 'scorer'">
                            <el-table :data="scorer" class="tableStyle" style="width: 100%">
                                <el-table-column type="index" label="排名"></el-table-column>
                                <el-table-column label="球员">
                                    <template slot-scope="scope">
                                        <div class="team-icon">
                                            <img :src="scope.row.person_logo">
                                            <b>{{ scope.row.person_name }}</b>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="球队">
                                    <template slot-scope="scope">
                                        <div class="team-icon">
                                            <img :src="scope.row.team_logo">
                                            <b>{{ scope.row.team_name }}</b>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="count" label="排名"></el-table-column>
                            </el-table>
                        </div>
                        <div v-else-if="item.bynameL === 'assists'">
                            <el-table :data="assistList" class="tableStyle" style="width: 100%">
                                <el-table-column type="index" label="排名"></el-table-column>
                                <el-table-column label="球员">
                                    <template slot-scope="scope">
                                        <div class="team-icon">
                                            <img :src="scope.row.person_logo">
                                            <b>{{ scope.row.person_name }}</b>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="球队">
                                    <template slot-scope="scope">
                                        <div class="team-icon">
                                            <img :src="scope.row.team_logo">
                                            <b>{{ scope.row.team_name }}</b>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="count" label="排名"></el-table-column>
                            </el-table>
                        </div>
                        <div class="schedule" v-else-if="item.bynameL === 'schedule'">
                            <div class="schedule-tit">
                                <span @click="prevRound(currentRound.params)" v-if="!(courseData.rounds && courseData.rounds.length > 0 && 'current' in courseData.rounds[0])" class="prev">&lt;上一轮</span>
                                {{currentRound.name}}
                                <span @click="nextRound(currentRound.params)" v-if="!(courseData.rounds && courseData.rounds.length > 0 && 'current' in courseData.rounds[courseData.rounds.length-1])" class="next">下一轮&gt;</span>
                            </div>
                            <div class="match-item" :class="{ 'odd-item': index % 2 === 0 }" v-for="(item,index) in courseData.matches">
                                <span class="start-min">
                                    {{ item.start_play | addHours }}
                                </span>
                                <div class="match-info">
                                    <p class="team-a">
                                        <span class="teama-name">
                                            {{item.team_A_name}}
                                        </span>
                                        <img :src="item.team_A_logo" alt="">
                                    </p>
                                    <div class="vs-score-wrap">
                                        <p class="feature">VS</p>
                                    </div>
                                    <p class="team-b">
                                        <span class="teamb-name">
                                            {{item.team_B_name}}
                                        </span>
                                        <img :src="item.team_B_logo" alt="">
                                    </p>
                                </div>
                            </div>
                        </div>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="射手榜" name="second">射手榜</el-tab-pane>
                    <el-tab-pane label="助攻榜" name="third">助攻榜</el-tab-pane>
                    <el-tab-pane label="赛程" name="fourth">赛程</el-tab-pane> -->
                </el-tabs>
            </div>
        </div>
    </div>
</template>
<script>
import Breadcrumb from '../../components/Breadcrumb.vue';
import { getMatchList } from '../../api/index'
export default {
    name: 'App',
    components: {
        Breadcrumb
    },
    data() {
        return {
            activeName:'standing',
            selectedIndex: 0,
            tableData: [],
            scorer:[],
            courseData:[],
            assistList:[],
            list: [{
				name: '积分榜',
				bynameL:'standing',
			}, {
				name: '射手榜',
				bynameL:'scorer',
			}, {
				name: '助攻榜',
				bynameL:'assists',
			}, {
				name: '赛程榜',
				bynameL:'schedule',
			}],
            ballTypeList: [{
				name: '中超',
				bynameL:'csl',
			}, {
				name: '英超',
				bynameL:'eng',
			}, {
				name: '西甲',
				bynameL:'spa',
			}, {
				name: '德甲',
				bynameL:'ger',
			}, {
				name: '意甲',
				bynameL:'ita',
			}, {
				name: '法甲',
				bynameL:'fra',
			}, {
				name: '欧冠',
				bynameL:'ucl',
			}],
            curIndex:0,
            currentRound:''
        };
    },
    filters: {
		addHours(timeStr) {
			if (!timeStr) return "";
			  
			const date = new Date(timeStr.replace(/-/g, '/'));
			date.setHours(date.getHours() + 8);
			  
			const pad = num => String(num).padStart(2, '0');
			  
			return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
		},
	},
    created(){
        // this.getFootBallData();
        console.log(this.$route.query,'this.$route.params.')
        if(this.$route.query){
            this.curIndex = Number(this.$route.query.curIndex);
            this.selectedIndex = Number(this.$route.query.selectedIndex);
            this.activeName = this.list[this.curIndex].bynameL;
            this.getFootBallData(this.list[this.curIndex].bynameL,this.ballTypeList[this.selectedIndex].bynameL);
        }
    },
    methods: {
        prevRound(el){
			const rounds = this.courseData.rounds || [];
			const currentIndex = rounds.findIndex(item => item.current === true);
			if (currentIndex > 0) {
			  const prevRound = rounds[currentIndex - 1];
			  let params = {
			  	match: 'schedule',
			  	match_key: this.ballTypeList[this.selectedIndex].bynameL,
			  	gameweek: this.selectedIndex == 6 ? prevRound.params.gameweek : el.gameweek - 1,
			  	round_id: this.selectedIndex == 6 ? prevRound.params.round_id : el.round_id
			  }
			  getMatchList(params).then(res=>{
			  	console.log(res,'res');
			  	this.courseData = { ...res.data.data.content };
			  	const currentRound = this.courseData.rounds.find(item => item.current === true);
			  	if (currentRound) {
			  		this.currentRound = currentRound;
			  	} else {
			  	    console.log("没有找到当前轮次");
			  	}
			  })
			}
		},
        nextRound(el){
			const rounds = this.courseData.rounds || [];
			const currentIndex = rounds.findIndex(item => item.current === true);
			if (currentIndex !== -1 && currentIndex < rounds.length - 1) {
			  const nextRound = rounds[currentIndex + 1];
			  let params = {
			  	match: 'schedule',
			  	match_key: this.ballTypeList[this.selectedIndex].bynameL,
			  	gameweek: this.selectedIndex == 6 ? nextRound.params.gameweek : el.gameweek + 1,
			  	round_id: this.selectedIndex == 6 ? nextRound.params.round_id : el.round_id
			  }
			  getMatchList(params).then(res=>{
			  	console.log(res,'res');
			  	this.courseData = { ...res.data.data.content };
			  	const currentRound = this.courseData.rounds.find(item => item.current === true);
			  	if (currentRound) {
			  		this.currentRound = currentRound;
			  	} else {
			  	    console.log("没有找到当前轮次");
			  	}
			  })
			}
		},
        handleClick(tab){
            console.log(tab.index)
            this.activeName = tab.name;
            this.curIndex = tab.index;
            if(!(this.curIndex == 0 && this.selectedIndex == 6)){
                this.getFootBallData(tab.name,this.ballTypeList[this.selectedIndex].bynameL);
            }
        },
        selectType(index) {
            this.selectedIndex = index;
            if(!(this.curIndex == 0 && this.selectedIndex == 6)){
                this.getFootBallData(this.list[this.curIndex].bynameL,this.ballTypeList[index].bynameL);
            }
        },
        getFootBallData(match,match_key){
			let params = {
				match: match, 
				match_key: match_key
			}
			getMatchList(params).then(res=>{
				console.log(res,'res');
                if(this.curIndex == 0){
                    if(res.code != 0){
                        this.tableData = res.data.data.content.rounds[0].content;
                    }else{
                        this.tableData = res;
                    }
                }else if(this.curIndex == 1){
                    this.scorer = res.data.data.content.data;
                }else if(this.curIndex == 2){
                    this.assistList  = res.data.data.content.data;
                }else if(this.curIndex == 3){
                    this.courseData = res.data.data.content
					const currentRound = this.courseData.rounds.find(item => item.current === true);
					if (currentRound) {
						this.currentRound = currentRound;
					} else {
					    console.log("没有找到当前轮次");
					}
                }
			})
		},
    }
}
</script>
<style scoped>
.infoMain{
    background: #FFFFFF;
    border-radius: 8px;
    padding: 20px;
    min-height: 450px;
    display: flex;
    justify-content: space-between;
}
.wrap1200 {
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    position: relative;
}
.el-tabs__item.is-active{
    color: #EA4747 !important;
}
.el-tabs__active-bar{
    background-color:#EA4747 !important;
}
.el-tabs__item:hover{
    color: #EA4747;
}
.matchType{
    width: 200px;
    ul li{
        list-style: none;
        height: 48px;
        line-height: 48px;
        font-size: 16px;
        background: #fff;
        position: relative;
        text-indent: 20px;
        cursor: pointer;
    }
    .select-bar {
        width: 6px;
        height: 48px;
        background: #f47559;
        position: absolute;
        margin-right: 15px;
        left: 0;
        top: 0;
    }
}
.matchType ul li.selected {
    color: #f47559 !important;
    background: #f7f7f7;
}
.matchMain{
    width: 940px;
}
.pointsTitle{
    width: 100%;
    text-align: center;
    background: #f47559;
    color: #FFFFFF;
    height: 42px;
    line-height: 42px;
    font-size: 18px;
}
.team-icon{
    width: 220px;
    text-align: left;
    text-indent: 20px;
    display: flex;
    align-items: center;
    img{
        height: 30px;
        margin: 0 5px 0 0;
        float: left;
    }
    b{
        font-weight: 400;
        width: 160px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        float: left;
        display: inline-block;
        text-indent: 0;
    }
}
.tableStyle >>> .el-table__header thead {
    color: #FFFFFF !important;
}
.tableStyle >>> .el-table__header tr {
    background-color: #f47559 !important;
}
.tableStyle >>> .el-table__header th.el-table__cell{
    background-color: #f47559 !important;
}
.schedule{
    font-size: 16px;
}
.schedule-tit {
    width: 100%;
    height: 50px;
    line-height: 50px;
    background: #f47559;
    color: #fff;
    text-align: center;
    font-size: 16px;
    position: relative;
    .prev {
        position: absolute;
        left: 20px;
        cursor: pointer;
    }
    .next {
        position: absolute;
        right: 20px;
        cursor: pointer;
    }
}
.match-item {
    width: 100%;
    height: 60px;
    line-height: 60px;
    overflow: hidden;
    color: #000;
    .start-min {
        float: left;
        width: 170px;
        text-indent: 22px;
        white-space: nowrap;
        text-overflow: hidden;
        overflow: hidden;
        margin-right: 16px;
        font-size: 14px;
    }
    .match-info {
        height: 60px;
        overflow: hidden;
        .team-a {
            float: left;
            height: 60px;
            overflow: hidden;
            .teama-name {
                width: 220px;
                text-align: right;
                display: inline-block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            img {
                width: 26px;
                float: right;
                margin-top: 18px;
                margin-left: 10px;
            }
        }
        .vs-score-wrap {
            width: 78px;
            float: left;
            text-align: center;
        }
        .team-b {
            float: left;
            height: 60px;
            overflow: hidden;
            .teamb-name {
                width: 132px;
                text-align: left;
                display: inline-block;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
            }
            img {
                width: 26px;
                float: left;
                margin-top: 18px;
                margin-right: 10px;
            }
        }
    }
}
.match-item.odd-item {
  background-color: #f7f7f7;
}
</style>


// WEBPACK FOOTER //
// src/views/football/course.vue